import angular from 'angular';
import autoCompleteModule from './autocomplete/autocomplete';
import whenScrolledModule from './when-scrolled/when-scrolled';
import ModalResponseController from './modal-response/modal-response.controller';
import ModalVideoController from './modal-video/modal-video.controller';
import OfflineModalController from './offline-modal/offline-modal.controller';
import ModalRecommendProductController from './modal-recommend-product/modal-recommend-product.controller';
import restrictType from './restrict-type/restrict-type';
import sessionModule from './session/session';
import MenuDropdownModule from './menu-dropdown/menu-dropdown';
import MenuToggleModule from './menu-toggle/menu-toggle';
import BannersModule from './banners/banners';
import ModalMapController from './modal-map/modal-map.controller';
import TestimoniesModule from './testimonies/testimonies';
import StoreFeatures from './store-features/store-features';
import Advertisement from './advertisement/advertisement';
//import Terms from './terms/terms';
//import Faq from './faq/faq';
import ModalDriverController from './modal-driver/modal-driver.controller';
import ModalLocationController from './modal-location/modal-location.controller';
import ModalSelectClientController from './modal-select-client/modal-select-client.controller';
import ModalSelectModalidadController from './modal-select-modalidad-pago/modal-select-modalidad-pago';
import staticViews from './static-views/static-views';

let sharedComponentsModule = angular.module('shared.components', [
    autoCompleteModule.name,
    whenScrolledModule.name,
    MenuDropdownModule.name,
    MenuToggleModule.name,
    BannersModule.name,
    staticViews.name,
    TestimoniesModule.name,
    sessionModule.name,
    StoreFeatures.name,
    Advertisement.name,
   // Terms.name,
   // Faq.name

])
    .controller('ModalResponseController', ModalResponseController)
    .directive('restrictType', restrictType)
    .controller('OfflineModalController', OfflineModalController)
    .controller('ModalSelectClientController', ModalSelectClientController)
    .controller('ModalSelectModalidadController', ModalSelectModalidadController)
    .controller('ModalMapController', ModalMapController)
    .controller('ModalDriverController', ModalDriverController)
    .controller('ModalLocationController', ModalLocationController)
    .controller('ModalRecommendProductController', ModalRecommendProductController)
    .controller('ModalVideoController', ModalVideoController)
    .filter('toTrusted', ['$sce', function ($sce) {
        return function (text) {
            return $sce.trustAsHtml(text);
        };
    }]);


export default sharedComponentsModule;



/** WEBPACK FOOTER **
 ** ./www/components/shared/components/shared-components.js
 **/